import { LastMedicalTreatmentConsentQuery } from '@dreryk/egabinet-patient-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { Link } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';
import { MedicalTreatmentConsentWithdrawEventInterceptor } from '../MedicalTreatmentConsentWithdrawEventInterceptor';

import { useMedicalTreatmentConsentWithdrawCommand } from './MedicalTreatmentConsentWithdrawAction.hooks';

export type MedicalTreatmentConsentWithdrawActionProps = {
   readonly patientId: number;
};

export const MedicalTreatmentConsentWithdrawAction = ({
   patientId,
}: MedicalTreatmentConsentWithdrawActionProps): JSX.Element => {
   const { loading, execute: withdrawConsent } = useMedicalTreatmentConsentWithdrawCommand({
      patientId: patientId,
      onSuccess: () => {
         refetchCqrsQuery(LastMedicalTreatmentConsentQuery);
      },
   });

   const onClick = (): void => {
      withdrawConsent();
   };

   return (
      <MedicalTreatmentConsentWithdrawEventInterceptor>
         <Link
            testId={'withdrawConsent'}
            label={patientConsentsAndAuthorizationsTranslationKeys.consent.withdrawButtonLabel}
            onClick={onClick}
            disabled={loading}
         />
      </MedicalTreatmentConsentWithdrawEventInterceptor>
   );
};
